import React, { useState, useEffect, useRef } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch, useSelector } from "react-redux";
import { getLoginType, getSequnceSort } from "../../../../utils/helper";
import { selectOptionData, showModal } from "../../../../redux/actions";
import * as image from "../../../../resources/images";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getDimModuleChallngObj, postModuleChallenge } from "../../../../redux/actions/APIs";
import { ShimmerCategoryList } from "react-shimmer-effects";
import UserActivityProgress from "../../../home/UserActivityProgress";
import UserQuiz from "../../../home/UserQuiz";
import UserCongratulations from "../../../home/UserCongratulations";
const LessonModuleCallengeRightpanel = (myProps) => {
    const param = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    
    const {
        defaultChildData,
        loggedInUser,
        selectOptData,
        kcSubmitResponse,
        dimModuleObjResp,
        socialActivityData,
    } = useSelector((state) => state.collections);

    const loginType = getLoginType(loggedInUser);

    const [indexOfRightPnl, setIndexOfRightPnl] = useState(0);
    const [surveyIndex, setSurveyIndex] = useState(0);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [isNext, setIsNext] = useState(true);
    const [courseData, setCourseData] = useState();

    useEffect(() => {
        dispatch(selectOptionData({
            type: "",
            title: "",
            questionData: {},
            optNuggetData: []
        }));
    }, [])

    useEffect(() => {
        if (location?.state?.course) {
            setCourseData(location?.state?.course);
        }
    }, [location])

    useEffect(() => {
        // console.log("useEffect selectOptData : ", selectOptData, kcSubmitResponse, dimModuleObjResp);
        if (selectOptData) {
            let tempActivity = dimModuleObjResp?.records[0];
            let isCongratulation = true;
            dimModuleObjResp?.records[0]?.survey?.map((data, index) => {
                data?.questions?.map((qustObj, key) => {
                    if (!qustObj?.attempted && isCongratulation) {
                        isCongratulation = false;
                    }
                })
            })
            if (!isCongratulation && surveyIndex === tempActivity?.survey?.length - 1 && questionIndex === tempActivity?.survey[surveyIndex]?.questions?.length - 1) {
                setIsNext(false);
            } else {
                setIsNext(true);
            }

            if (selectOptData?.type === "" && kcSubmitResponse?.success && !dimModuleObjResp?.records[0]?.isComplete && indexOfRightPnl === 2) {
                if (isCongratulation) {
                    setIndexOfRightPnl(indexOfRightPnl + 1);
                    setSurveyIndex(0);
                    dispatch(postModuleChallenge());
                }
            }
        }

    }, [selectOptData])

    useEffect(() => {
        if (dimModuleObjResp?.records?.length > 0) {
            if (!dimModuleObjResp?.records[0]?.isComplete) {
                setIndexOfRightPnl(1);
            } else if (dimModuleObjResp?.records[0]?.isComplete) {
                setIndexOfRightPnl(3);
            }
        }
        else {
            setIndexOfRightPnl(0);
        }
    }, [dimModuleObjResp])

    const [getOptionId, setOptionId] = useState();
    const [getOptionIdArr, setOptionIdArr] = useState([]);

    const handleSubmit = (qustionObj, optionObj) => {
        let kcpoints = 0;
        optionObj.isUserSelected = true;

        if (optionObj?.attempted && optionObj?.isCorrect) {
            qustionObj.attempted = true;

        }
        dispatch(selectOptionData({ ...selectOptData, type: "ShowNuggetPopup" }));
        // console.log("etOptionId !== optionObj : ",getOptionId, optionObj?.id, getOptionId !== optionObj?.id);
        if (getOptionId !== optionObj?.id) {
            qustionObj.invalidAttempt = qustionObj?.invalidAttempt + 1;
            if (qustionObj?.attempted) {
                kcpoints = qustionObj.invalidAttempt === 1 ? 10 : 5;
            }
            if (qustionObj.invalidAttempt === 3) {
                kcpoints = 1;
                qustionObj?.options?.map((optObj, key) => {
                    if (optObj?.isCorrect) {
                        optObj.attempted = true;
                        qustionObj.attempted = true;
                    } else {
                        optObj.attempted = false;
                    }
                })
            }
            const body = {
                questionId: qustionObj?.id,
                invalidAttempt: qustionObj.invalidAttempt,
                type: qustionObj?.type,
                answer: "",
                optionIds: [optionObj?.id],
                kcpoints: kcpoints
            };
            KnowladgecheckHandler(body, qustionObj);
            setOptionId(optionObj?.id);
        }

    }


    const KnowladgecheckHandler = async (attemptBodyData, qustionObj) => {
        let getActivityData = dimModuleObjResp?.records[0];
        dispatch(
            postModuleChallenge(
                defaultChildData.id,
                getActivityData?.activityId,
                qustionObj?.surveyId,
                attemptBodyData,
            )
        );
        //	getActivityData.points += attemptBodyData?.kcpoints;
        if (qustionObj?.attempted) {
            dimModuleObjResp.records[0].points += attemptBodyData?.kcpoints;
        }
    };

    const handleSubmitCheckBox = (qustionObj, optionObj) => {
        let kcpoints = 0;
        let selectOptId = [];
        let correctOptIds = [];
        let attemptOptIds = [];
        let isSubmit = false;
        qustionObj?.options?.map((item, key) => {
            if (item?.attempted) {
                item.isUserSelected = true;
                selectOptId?.push(item?.id);
            }
            if (item?.isCorrect) {
                correctOptIds?.push(item?.id);
            }
            if (item?.attempted && item?.isCorrect) {
                attemptOptIds?.push(item?.id);
            }
        })

        if (correctOptIds?.length === attemptOptIds?.length && correctOptIds?.length === selectOptId?.length) {
            qustionObj.attempted = true;
        }
        let title = qustionObj?.attempted ? "Well Done!" : "Close! Keep Going!";
        dispatch(selectOptionData({ ...selectOptData, title: title, type: "ShowNuggetPopup" }));
        qustionObj?.options?.map((opt, key) => {
            const idKey = getOptionIdArr?.findIndex((myId) => myId === opt?.id)
            console.log("opt?.attempted && idKey === -1 && !isSubmit : ", opt?.attempted, idKey, isSubmit, getOptionIdArr);
            if (opt?.attempted && idKey === -1 && !isSubmit) {
                isSubmit = true;
            }
            if (!opt?.attempted && idKey !== -1 && !isSubmit) {
                isSubmit = true;
            }
        })


        console.log("isSubmit @@@ : ", isSubmit, );
        if (isSubmit) {
            qustionObj.invalidAttempt = qustionObj?.invalidAttempt + 1;
            if (qustionObj?.attempted) {
                kcpoints = qustionObj.invalidAttempt === 1 ? 10 : 5;
            }
            if (qustionObj.invalidAttempt === 3) {
                kcpoints = 1;
                qustionObj?.options?.map((optObj, key) => {
                    if (optObj?.isCorrect) {
                        optObj.attempted = true;
                        qustionObj.attempted = true;
                    } else {
                        optObj.attempted = false;
                    }
                })
            }
            const body = {
                kcpoints: kcpoints,
                questionId: qustionObj?.id,
                optionIds: selectOptId,
                invalidAttempt: qustionObj.invalidAttempt,
                type: qustionObj?.type,
                answer: "",
                activityTime: "",
                isKc: true,
            };
            KnowladgecheckHandler(body, qustionObj);
            // console.log("KnowladgecheckHandler : ", body, qustionObj);
            setOptionIdArr(selectOptId);
        }

    }




    const handleShowRightPnl = () => {
        let tempActivity = dimModuleObjResp?.records[0];
        if (loginType && socialActivityData?.records[0]?.completion < 100) {
            myProps.setDeletePlan({
                title: 'Module Challenge',
                message: `Please complete all Lessons of Module ${socialActivityData?.records[0]?.activitySequence} before proceeding to the Module Challenge.`,
            });
            return;
        }
        if (selectOptData?.type) {
            dispatch(selectOptionData({ ...selectOptData, type: "" }));
        }
        if ((indexOfRightPnl === 1 || (indexOfRightPnl === 2 && surveyIndex === tempActivity?.survey?.length - 1 && questionIndex === tempActivity?.survey[surveyIndex]?.questions?.length - 1))) {
            setIndexOfRightPnl(indexOfRightPnl + 1)
            setSurveyIndex(0);
            return;
        }
        handleKcIndex(tempActivity);

    }

    const handleKcIndex = (tempActivity) => {
        if (questionIndex === tempActivity?.survey[surveyIndex]?.questions?.length - 1) {
            setSurveyIndex(surveyIndex + 1);
            setQuestionIndex(0);
        } else {
            setQuestionIndex(questionIndex + 1)
        }

    }

    const handleBack = () => {
        if (dimModuleObjResp?.records[0]?.survey?.length > 0 && indexOfRightPnl == 3) {
            setSurveyIndex(dimModuleObjResp?.records[0]?.survey?.length - 1);

        }
        if (surveyIndex > 0 && indexOfRightPnl == 2) {
            setSurveyIndex(surveyIndex - 1);
            return;
        }
        setIndexOfRightPnl(indexOfRightPnl - 1)
    }




    // console.log("myProps @@@ : ",myProps, selectOptData, indexOfRightPnl);

    return (
        <>
            <div className="">
                {/* <h2 className='flex'>
                    <div class="form-title mt-0 mb-0 Enrollcoursetitle heading summery_plan">
                        <h2 data-toggle="collapse" class="m-0 pt-0 pb-1 w-100 flex justify-content-between ">
                            <span>
                                {" "}
                                <img src={image.module_challenge} className="mr-2" alt="" />
                                Module Challenge
                            </span>
                        </h2>
                    </div>
                </h2> */}
                <>
                    {(!dimModuleObjResp || indexOfRightPnl === 0) ? (
                        (
                            <ShimmerCategoryList items={3} categoryStyle="STYLE_SIX" />
                        )
                    ) : (
                        <>
                            {indexOfRightPnl === 1 && (
                                <UserActivityProgress
                                    activityData={dimModuleObjResp?.records[0]}
                                    setShowVideoPopUp={myProps?.setShowVideoPopUp}
                                    handleVideoData={myProps?.handleVideoData}
                                    selectedCourse={courseData}
                                />
                            )}
                            {indexOfRightPnl === 2 && (
                                <UserQuiz
                                    getCompleteModuleData={dimModuleObjResp?.records[0]}
                                    moduleData={getSequnceSort(dimModuleObjResp?.records[0]?.survey)[surveyIndex]}
                                    questionIndex={questionIndex}
                                    setQuestionIndex={setQuestionIndex}
                                    setSurveyIndex={setSurveyIndex}
                                    surveyIndex={surveyIndex}
                                />
                            )}

                            {indexOfRightPnl === 3 && (
                                <UserCongratulations screenType={"LessonDetail"} />
                            )}
                        </>
                    )}



                </>
                {/*  */}
            </div>
            <div class="px-3 ">
                <div class="form-group BDsubmitbutton d-flex justify-content-right align-items-center m-0 w-100 flexone ">
                    <div class="flexone">
                        <button
                            class="myblue_btn myblylinktxt"
                            disabled={[0, 1]?.includes(indexOfRightPnl)}
                            // onClick={() => { setIndexOfRightPnl(indexOfRightPnl - 1), setSurveyIndex(0) }}
                            onClick={() => handleBack()}
                        >
                            <span>
                                {" "}
                                <i class="fa-solid fa-arrow-left m-0 mr-2"></i>
                            </span>
                            Previous
                        </button>
                    </div>
                    <div class="">
                        {(!loginType || [0, 1]?.includes(indexOfRightPnl) || selectOptData?.questionData?.attempted || indexOfRightPnl === 3) ? (
                            <button class="myblue_btn myblylinktxt"
                                disabled={indexOfRightPnl === 3 || indexOfRightPnl === 0 || (indexOfRightPnl === 2 && !isNext)}
                                onClick={() => { handleShowRightPnl() }}
                            >Next
                                <span>
                                    {" "}
                                    <i className="fa-solid fa-arrow-right m-0 ml-2"></i>
                                </span>
                            </button>
                        ) : (
                            <button
                                type="submit"
                                className="myblue_btn myblylinktxt"
                                disabled={!selectOptData?.optNuggetData[0]?.attempted}
                                onClick={() => {
                                    selectOptData?.questionData?.type === "RADIOQ" ? handleSubmit(selectOptData?.questionData, selectOptData?.optNuggetData[0])
                                        : handleSubmitCheckBox(selectOptData?.questionData, selectOptData?.optNuggetData[0])
                                }}
                            >
                                <span >
                                    <i className="fa-solid fa-paper-plane mr-2 m-0"></i>
                                </span>
                                Submit
                            </button>
                        )}
                    </div>
                    {/* <div class="w-100">
						<button
						type="button"
						className="btn-blue btn-login d-block mb-5 w-auto rocket_icon"
						onClick={() => handleGotoCourse()}
					>
						<i class="fa-light fa-rocket-launch mr-2"></i>
						Go to Course Catalog
					</button>
					</div> */}
                </div>
            </div>
        </>
    )
}
export default LessonModuleCallengeRightpanel;